export default __webpack_public_path__ + "static/media/rsp.f2dae78a.png";